module.exports = __webpack_public_path__ + "img/CNTE.16b57ed7.png";